import {
  Alert,
  AlertType,
  Button,
  ButtonVariant,
  Text,
  TextHighlight,
  TextSize,
  TextWeight,
  makeStyles,
  theme
} from '@focaldata/cin-ui-components'
import { useBaseMarketSetting } from './useBaseMarketSetting'

const useStyles = makeStyles()({
  hint: { marginTop: 4 },
  action: { marginTop: 12 },
  // Lined up with the audience cards, clear of the Market settings gear.
  notice: { margin: theme.spacing(4, 4, 1, 4) },
  noticeAction: { marginTop: 8 }
})

interface Props {
  isBase: boolean
  disabled: boolean
  onChoose: () => void
}

// The base moves when another market is chosen; it is never cleared.
export const BaseMarketSetting = ({ isBase, disabled, onChoose }: Props) => {
  const { classes } = useStyles()

  return (
    <>
      <Text size={TextSize.m} weight={TextWeight.SemiBold}>
        Base market
      </Text>
      <div className={classes.hint}>
        <Text size={TextSize.ms} highlight={TextHighlight.Background}>
          {isBase
            ? 'This is the base market. To move it, open another market’s settings.'
            : 'Global audience questions are edited in the base market.'}
        </Text>
      </div>
      {!isBase && (
        <div className={classes.action}>
          <Button
            variant={ButtonVariant.SecondaryOutlined}
            disabled={disabled}
            onClick={onChoose}
          >
            Make this the base market
          </Button>
        </div>
      )}
    </>
  )
}

// Until a wave has a base, no market offers the Global toggle.
export const BaseMarketNotice = () => {
  const { classes } = useStyles()
  const baseMarket = useBaseMarketSetting()

  if (!baseMarket.enabled || baseMarket.unknown || baseMarket.hasBase) {
    return null
  }

  return (
    <div className={classes.notice}>
      <Alert severity={AlertType.INFO}>
        This wave has no base market yet. Global audience questions are edited
        in the base market.
        <div className={classes.noticeAction}>
          <Button
            variant={ButtonVariant.SecondaryOutlined}
            disabled={baseMarket.saving}
            onClick={baseMarket.choose}
          >
            Make this the base market
          </Button>
        </div>
      </Alert>
    </div>
  )
}
